export { EventDetailLoadingSkeleton as default } from '../event/[id]';